import { deserialize, inheritSerialization } from 'cerialize'
import { FieldNames } from 'Constants/FieldNames'
import { AddressSuggest } from 'Models'
import { ActiveLead, BgLimitRequest, BgLimitRequestReceivingFile } from 'Pages/ibro'

@inheritSerialization(BgLimitRequest)
export class BgLimitRequestFull extends BgLimitRequest {
	@deserialize public confirmation_created_at?: string
	@deserialize public locked_fields?: FieldNames[]
	@deserialize public required_fields?: FieldNames[]
	@deserialize public doc_types?: FieldNames[]
	@deserialize public data_types?: FieldNames[]
	@deserialize public fio?: string
	@deserialize public email?: string
	@deserialize public phone?: string
	@deserialize public 'active_lead_present?': boolean
	@deserialize public active_leads?: ActiveLead[]
	@deserialize public addressjur?: AddressSuggest
	@deserialize public okvedanover?: string
	@deserialize public registrationdate?: string
	@deserialize public authpassport?: string
	@deserialize public authpassportser?: string
	@deserialize public authpassportnum?: string
	@deserialize public authpassportwhogive?: string
	@deserialize public authpassportdategive?: string
	@deserialize public authpassportkod?: string
	@deserialize public authaddress?: AddressSuggest
	@deserialize public authpersoncitizenship?: string
	@deserialize public authpersondate?: string
	@deserialize public authpersonplace?: string
	@deserialize public authposition?: string
	@deserialize public address?: string
	@deserialize public otherdocs?: BgLimitRequestReceivingFile
	@deserialize public registrationaddress?: string
	@deserialize public registrationtaxdate?: string
	@deserialize public oktmo?: string
	@deserialize public locked_by_service_request?: boolean
	@deserialize public authinn?: string
	@deserialize public actingunder?: string
	@deserialize public anketafsc?: BgLimitRequestReceivingFile
	@deserialize public financialstatement?: BgLimitRequestReceivingFile
	@deserialize public kpp?: string
	@deserialize public comments?: string
	@deserialize public ogrn?: string
	@deserialize public ogrnip?: string
	@deserialize public reject_description?: string
	@deserialize public external_url?: string
	@deserialize public ustav?: BgLimitRequestReceivingFile
	@deserialize public gendirscan?: BgLimitRequestReceivingFile
	@deserialize public protocolgendirscan?: BgLimitRequestReceivingFile
}

export type BgLimitRequestSaveModel = Partial<Omit<BgLimitRequestFull, 'id'>> &
	Pick<BgLimitRequestFull, 'id'>
